import FurnishingTableHelper from './furnishing-table-helper';


const FurnishingHelpers = {
    TableMain: FurnishingTableHelper,
}

export default FurnishingHelpers;